import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ruonn-replica/artifacts/652j8z6m_logo%20letra%20transparente%20white.png';

const Footer = () => {
  return (
    <footer className="bg-[#0a0a0b] py-12 px-6 border-t border-white/5">
      <div className="max-w-6xl mx-auto">
        {/* Footer Links Grid */}
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="Ruonn" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-gray-500 text-sm">
              Expert developers & QA services, plus AI-powered voice solutions for modern businesses.
            </p>
          </div>
          
          {/* Products */}
          <div>
            <h4 className="text-white font-medium mb-4">Products</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/voice-agent" className="text-gray-400 hover:text-white text-sm transition-colors">
                  AI Voice Agent
                </Link>
              </li>
              <li>
                <Link to="/voice-agent#pricing" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h4 className="text-white font-medium mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <a href="/#benefits" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Why Ruonn
                </a>
              </li>
              <li>
                <a href="/#testimonials" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="/#faq" className="text-gray-400 hover:text-white text-sm transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          
          {/* Get Started */}
          <div>
            <h4 className="text-white font-medium mb-4">Get Started</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/cloud/register" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Create Account
                </Link>
              </li>
              <li>
                <Link to="/cloud/login" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Login to Ruonn Cloud
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8">
          {/* Disclaimer */}
          <p className="text-gray-500 text-xs text-center mb-6 max-w-2xl mx-auto">
            This site is not a part of the Facebook website or Facebook Inc. Additionally, This site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          {/* Copyright */}
          <p className="text-gray-400 text-sm text-center">
            ©2024 ruonn.com. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
